import { Button } from "@mui/material";
import { useFormActions, useFormState } from "@ngt/forms-core";
import { FC, useCallback } from "react";

interface INextButtonProps {
    onClick: () => void;
    index: number;
    setComplete: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
}

const NextButton: FC<INextButtonProps> = ({ onClick, index, setComplete }) => {
    const {fields, errors} = useFormState({errors: true, fields: true})
    const {setTouched} = useFormActions()

    const onNext = useCallback((e: React.MouseEvent) => {
        const hasErrors = fields.reduce((a, b) => {
            if (a) {
                return a;
            }

            return errors[b]?.length > 0;
        }, false);

        if (!hasErrors) {
            onClick();
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
        else {
            setTouched((current) => {
                fields.forEach(path => {
                    current[path] = true;
                });
    
                return current;
            });

            document.querySelector('.error-normal')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }, [errors, fields]);

    return (
        <Button variant="contained" 
            onClick={onNext}
            sx={{
                float: "right",
                marginBottom: "50px",
                marginTop:"20px"
            }}>
            Next
        </Button>
    );
}

export default NextButton;